/**
 * Iter-158.13.2.20 — Route 2 Global Search deep-link helper.
 *
 * `useApiBase()` resolves to `/projects` on the legacy workspace and
 * `/beta/hm-app/projects` on the Route 2 (beta H&M) workspace. Both
 * bases already contain the `/projects` segment so the search
 * endpoint must NOT append another one:
 *
 *   legacy → `${apiBase}/${projectId}/search`
 *          = `/projects/{pid}/search`
 *   beta   → `/beta/hm-app/projects/{pid}/search`
 *
 * Callers pass the value returned by `useApiBase()`; the axios base
 * URL already carries `/api`.
 *
 * The helper exists so the search endpoint is defined in exactly one
 * place across the frontend. Any future hardcoded `/api/projects/…`
 * search URL that slips into the codebase will fail this file's
 * unit test and get caught before shipping.
 */
export function searchEndpoint(apiBase, projectId) {
    if (typeof apiBase !== "string" || !apiBase.startsWith("/")) {
        throw new TypeError("searchEndpoint: apiBase must be a path starting with '/'");
    }
    if (typeof projectId !== "string" || !projectId) {
        throw new TypeError("searchEndpoint: projectId must be a non-empty string");
    }
    return `${apiBase}/${projectId}/search`;
}
